import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const subscribeNewsletter = createServerFn({ method: "POST" })
  .inputValidator((input: { email: string; source?: string }) => {
    const email = String(input?.email ?? "").trim().toLowerCase();
    if (!email || email.length > 254 || !EMAIL_RE.test(email)) {
      throw new Error("Ogiltig e-postadress");
    }
    const source = String(input?.source ?? "footer").slice(0, 40);
    return { email, source };
  })
  .handler(async ({ data }) => {
    const supabase = createClient<Database>(
      process.env.SUPABASE_URL!,
      process.env.SUPABASE_PUBLISHABLE_KEY!,
      { auth: { persistSession: false, autoRefreshToken: false } },
    );

    // Idempotent: if already subscribed, still return success.
    const { error } = await supabase
      .from("newsletter_subscribers")
      .insert({ email: data.email, source: data.source });

    if (error && !/duplicate|unique/i.test(error.message)) {
      console.error("subscribeNewsletter insert failed", error);
      throw new Error("Kunde inte anmäla just nu. Försök igen.");
    }

    return { ok: true as const };
  });
